import React, {useEffect, useMemo} from "react";
import {Chart} from "react-google-charts";
import * as actions from "../../../actions/provisions/provisionsActions";
import {useDispatch, useSelector, shallowEqual} from "react-redux";
import {useProvisionsUIContext} from "../ProvisionsUIContext";
import {getTicks} from "../../../utils/utility";
import configuration from "../../../../shared/configuration";
import {useLanguageForShared} from "../../../../shared/utils/languages/useLanguageForShared";

export function ProvisionsChart() {
    const {t} = useLanguageForShared()

    const provisionsUIContext = useProvisionsUIContext();
    const provisionsUIProps = useMemo(() => {
        return {
            queryParams: provisionsUIContext.queryParams,
        };
    }, [provisionsUIContext]);

    const {currentState} = useSelector(
        (state) => ({currentState: state.provisions}),
        shallowEqual
    );

    const {provisionsChart} = currentState;

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(actions.fetchProvisionsChart(provisionsUIProps.queryParams));
        charts();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [provisionsUIProps.queryParams, dispatch]);

    function charts() {
        if (provisionsChart && provisionsChart.length > 0) {
            let graphs = [];
            let colors = [configuration.theme.series.s770_hex, configuration.theme.series.s870_hex, configuration.theme.series.s170_hex];
            let colorIndex = 0;
            let chartIndex = 0;

            provisionsChart.forEach((element) => {
                let dataTable = [[t('lsi.chart.provisions'), t('lsi.chart.total')]];

                let maxValue = 0;

                element.values.forEach((el) => {
                    dataTable.push([el.provisionType, el.count]);
                    if (el.count > maxValue) {
                        maxValue = el.count;
                    }
                });

                let graphColors = [];

                if (colors[colorIndex]) {
                    graphColors = [colors[colorIndex]];
                } else {
                    colorIndex = 0;
                    graphColors = [colors[colorIndex]];
                }

                let monthYear = element.values[0].monthName + " " + element.values[0].year;

                let vticks = getTicks(maxValue, 4);

                const chartOptions = {
                    colors: graphColors,
                    fontName: configuration.theme.fontFamily,
                    fontSize: 14,
                    title: monthYear,
                    titleTextStyle: {
                        italic: false,
                        fontSize: 18,
                        bold: false,
                        color: configuration.theme.primaryDark,
                    },
                    chartArea: {
                        width: "100%",
                        left: 60,
                        top: 40,
                        bottom: 70
                    },
                    bar: {
                        groupWidth: 40
                    },
                    hAxis: {
                        title: t('lsi.chart.provisions'),
                        viewWindowMode: "pretty",
                        titleTextStyle: {
                            italic: false,
                            color: configuration.theme.primaryDark,
                        },
                        textStyle: {
                            italic: false,
                            color: configuration.theme.primaryDark,
                        },
                        slantedText: false,
                    },
                    vAxis: {
                        title: "",
                        ticks: vticks,
                        titleTextStyle: {
                            italic: false,
                            color: configuration.theme.primaryDark,
                        },
                        textStyle: {
                            italic: false,
                            color: configuration.theme.primaryDark,
                        },
                        baselineColor: "#F2F2F2",
                        gridlines: {
                            color: "#F2F2F2"
                        }
                    },
                    legend: {
                        position: "none",
                    }
                };

                graphs.push(
                    <Chart chartType="ColumnChart" height={200} data={dataTable} options={chartOptions}
                           key={"chart" + chartIndex}/>
                );

                colorIndex++;
                chartIndex++;
            });

            return graphs;
        } else {
            return (
                <span>{t('lsi.noDataAvailable')}</span>
            );
        }
    }

    return (
        charts()
    );
}
